import { Input as AntdInput, InputProps, Form } from 'antd';
import { FormItemProps } from '@ant-design/compatible/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import styled from 'styled-components';

import { InputLabelWithTooltip } from './components/InputLabelWithTooltip';
import { FormInputProps } from './models';

const StyledFormItem = styled(Form.Item)<{ nobottommargin: number }>(
    ({ nobottommargin }) => `
        margin-bottom: ${nobottommargin ? 0 : '1rem'};
`,
);

interface Props
    extends Omit<FormItemProps, 'label'>,
        Omit<InputProps, 'label' | 'name'>,
        FormInputProps {
    name: NamePath;
    validationLabel?: string;
    noBottomMargin?: boolean;
}

export const Input = ({
    name,
    placeholder,
    label,
    type = 'string',
    required = true,
    requiredMessage,
    disabled = false,
    hidden,
    autoComplete,
    tooltip,
    help,
    validateStatus,
    initialValue,
    noBottomMargin,
}: Props) => (
    <StyledFormItem
        name={name}
        label={
            tooltip ? (
                <InputLabelWithTooltip label={label || placeholder} tooltip={tooltip} />
            ) : (
                label || placeholder
            )
        }
        help={help}
        validateStatus={validateStatus}
        rules={[
            {
                required,
                message: requiredMessage || `${label || placeholder} is required`,
            },
        ]}
        hidden={hidden}
        initialValue={initialValue}
        nobottommargin={noBottomMargin ? 1 : 0}
    >
        <AntdInput
            type={type}
            size="large"
            placeholder={placeholder || label}
            disabled={disabled}
            hidden={hidden}
            autoComplete={autoComplete}
        />
    </StyledFormItem>
);
